import * as React from 'react';

import { enumUnit } from '@rematter/frontend-lib-api-client';
import { enumLoadWeightType } from '@rematter/modules/trade/types/load';
import { convertWeightForPricing } from '@rematter/modules/trade/utils/weight';
import { weightToPounds } from '@rematter/ui-web';

import { EstimatedPriceFieldCellProps } from '../types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { PriceFieldCell } from '~/shared/components/line-items';

export const EstimatedPriceFieldCell: React.FC<
  EstimatedPriceFieldCellProps
> = ({ lineItem, disabled }) => {
  const t = useTranslations();
  const convertedWeightPounds = weightToPounds(
    lineItem.weights?.[enumLoadWeightType.Net],
  );

  const convertedNetWeight = convertWeightForPricing(
    convertedWeightPounds,
    lineItem?.pricingUnit ?? enumUnit.Pounds,
  );

  const unitPriceAmount = lineItem.unitPrice?.amount ?? null;

  const estimatedTotal = React.useMemo(
    () =>
      unitPriceAmount !== null ? unitPriceAmount * convertedNetWeight : null,
    [convertedNetWeight, unitPriceAmount],
  );

  if (estimatedTotal === null && lineItem.itemId) {
    return (
      <div className="@EstimatedPriceFieldCell flex h-full items-center justify-end px-2 text-sm text-neutral/40">
        {t.scaleTicketPro.columns.priceTbd}
      </div>
    );
  }

  return (
    <PriceFieldCell
      value={estimatedTotal ?? 0}
      disabled={disabled}
      className="@EstimatedPriceFieldCell"
    />
  );
};
